module.exports = __webpack_public_path__ + "static/media/wizualizacja-65.96a61210.png";